<template>
  <div :class="['health-container', healthColour]">
    <template v-if="health.level">
      <div class="health-topbar">
        <div class="health-topbar__logo">
          <img :src="logo" />
          <router-link
            id="sign-in"
            :to="{ name: 'login' }"
            class="health-topbar__signin"
          >
            Sign In
            <span
              id="sign-in-icon"
              v-html="arrowIcon"
            />
          </router-link>
        </div>
      </div>
      <div class="health__level">
        <span
          class="health__level-icon"
          v-html="healthIcon"
        ></span>
        {{ health.level }}
      </div>
      <div class="health__message">
        {{ health.message }}.
      </div>
    </template>
  </div>
</template>

<script>
import healthCheckQueries from '@/graphql/systemHealth.js'
import bioconnectLogo from '@/assets/logos/link_logo_dark.svg'
import feather from 'feather-icons'

export default {
  name: 'HealthCheck',
  mixins: [healthCheckQueries],
  data() {
    return {
      logo: bioconnectLogo,
      arrowIcon: feather.icons['arrow-right'].toSvg({width: '1.2em'}),
      healthLevels: {
        healthy: {
          style: 'health-container--sunshine',
          icon: this.sunshine(),
        },
        unhealthy: {
          style: 'health-container--cloudy',
          icon: this.cloud(),
        },
        critical: {
          style: 'health-container--storm',
          icon: this.storm(),
        },
      },
      health: {
        level: '',
        message: '',
      },
    }
  },
  computed: {
    healthColour() {
      if (this.health.level) {
        return this.healthLevels[this.health.level].style
      }
      return null
    },
    healthIcon() {
      if (this.health.level) {
        return this.healthLevels[this.health.level].icon
      }
      return null
    },
  },
  created() {
    this.getHealth()
  },
  methods: {
    async getHealth() {
      try {
        const _result = await this.healthCheck()
        const {level, message} = _result
        this.health = {level, message}
      } catch (error) {
        console.log(error)
      }
    },
    sunshine() {
      return `
        <svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-sun"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
      `
    },
    cloud() {
      return `
        <svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-cloud"><path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path></svg>
      `
    },
    storm() {
      return `
        <svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-cloud-lightning"><path d="M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"></path><polyline stroke="#f1c40f" points="13 11 9 17 15 17 11 23"></polyline></svg>
      `
    },
  },
}
</script>

<style lang="scss" scoped>
.health {
  &-topbar {
    @include flex-display();
    @include flex-align-items(flex-end);
    @include flex-justify-content(space-between);
    background: $white;
    height: $nav-bar-height;
    width: 100%;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 1em;
    position: absolute;
    top: 0;
    left: 0;
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.35);
    &__signin {
      @include flex-display();
      @include flex-align-items(center);
      margin-right: 1em;
      #sign-in-icon {
        transition: transform 0.2s ease-out;
      }
      &:hover {
        #sign-in-icon {
          transform: translateX(0.5em);
        }
      }
    }
    &__logo {
      @include flex-display();
      @include flex-justify-content(space-between);
      @include flex-align-items(center);
      height: 100%;
      width: 100%;
      img {
        margin-right: 1em;
        height: 40px;
        width: auto;
      }
    }
    &__link {
      text-decoration: underline;
      &:hover {
        cursor: pointer;
      }
    }
  }
  &-container {
    width: 100vw;
    height: 100vh;
    color: $white;
    @include flex-display();
    @include flex-justify-content(center);
    @include flex-align-items(center);
    @include flex-direction(column);
    &--sunshine {
      background-color: $green;
    }
    &--cloudy {
      background-color: #95a5a6;
    }
    &--storm {
      background-color: #2c3e50;
    }
  }
  &__level {
    @include flex-display();
    @include flex-align-items(center);
    text-transform: capitalize;
    font-size: 8em;
    margin-bottom: 0.2em;
    font-weight: bold;
    @media #{$mobile} {
      @include flex-justify-content(center);
      flex-wrap: wrap;
      font-size: 4em;
    }
    &-icon {
      margin-right: 0.2em;
    }
  }
  &__message {
    font-size: 1.5em;
    margin-bottom: 2em;
    @media #{$mobile} {
      font-size: $default-font;
    }
  }
}
</style>
